/* eslint-disable max-len */
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import uuid4 from 'uuid4';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {
  startRequest as requestLoading,
  requestSuccess as successLoading,
  requestError as errorLoading,
} from '~/redux/ducks/loading';

import {Creators as ToastrMessageActions} from '~/redux/ducks/toastrMessage';

import PreviewImageBox from './components/PreviewImageBox';
import UploadImage from '~/Components/UploadImage';
import Upload from '~/Components/Upload';
import Button from '~/Components/Button';

import {
  Container,
  Card,
  Header,
  Body,
  ImagemItem,
  ImagemItemHeader,
  ImagemEdit,
  ImagemEditInfo,
  Separator,
  Input,
  ErrorMessage,
  BaseContentInput,
  SuccessInfoCard4,
} from './styles';
import FileUploadService from '~/services/FileUploadService';
import ImageFromService from '~/Components/ImageFromService';
import InputCreativeAdvanced from '../../Components/InputCreativeAdvanced';
import {formatBytes} from '~/Utils';
import VideoFromService from "~/Components/VideoFromService";


const RCSClaroForm = ({
                        campaign,
                        criativoEdit,
                        campaignEditCriativoRequestSuccess,
                        hasError,
                        disabledFields,
                        startRequest,
                        requestSuccess,
                        requestError,
                        errorMessage,
                      }) => {
  const [statusError, setStatusError] = useState({
    messageErrorImageCampaign: '',
    messageErrorImageInfo1: '',
    messageErrorImageInfo2: '',
    messageErrorImageInfo3: '',
  });
  const {content, creativeDefinition: {schema}} = criativoEdit;
  const {
    cards, ...rest
  } = schema;

  const {mediaType} = content;

  const [cardsData, setCardsData] = useState({...cards});

  useEffect(() => {
    if (!cards) {
      const defaultMediaType = rest[mediaType] || rest[Object.keys(rest)[0]];
      changeContent({...content, mediaType: mediaType || Object.keys(rest)[0]})
      setCardsData(defaultMediaType.cards);
    }
  }, [mediaType]);

  async function uploadFile(file, field) {
    const {uuid: campaignUuid} = campaign;

    const referenceKey = `${campaignUuid}-${field}-${uuid4()}`;

    try {
      startRequest();
      const formData = new FormData();
      formData.append('file', file);
      const {uuid} = await FileUploadService.uploadFile(formData, referenceKey);
      requestSuccess();
      return uuid;
    } catch (e) {
      errorMessage(
        'Atenção!',
        'Houve um problema ao enviar a imagem. Tente novamente mais tarde!',
      );
      requestError();
    }
    return null;
  }

  function changeContent(data) {
    campaignEditCriativoRequestSuccess({
      ...criativoEdit,
      content: {
        ...data,
      },
    });
  }

  async function uploadImageCampaign(files) {
    const file = files[0];
    if (file) {
      const fileUuid = await uploadFile(file, 'imageCampaign');
      changeContent({
        ...content,
        imageCampaign: fileUuid,
      });
    }
  }

  async function uploadThumbnailCampaign(files) {
    const file = files[0];
    if (file) {
      const fileUuid = await uploadFile(file, 'thumbnail');
      changeContent({
        ...content,
        thumbnail: fileUuid,
      });
    }
  }

  async function uploadImageInfo1(files) {
    const file = files[0];
    if (file) {
      const fileUuid = await uploadFile(file, 'imageInfo1');
      changeContent({
        ...content,
        imageInfo1: fileUuid,
      });
    }
  }

  async function uploadImageInfo2(files) {
    const file = files[0];
    if (file) {
      const fileUuid = await uploadFile(file, 'imageInfo2');
      changeContent({
        ...content,
        imageInfo2: fileUuid,
      });
    }
  }

  async function uploadImageInfo3(files) {
    const file = files[0];
    if (file) {
      const fileUuid = await uploadFile(file, 'imageInfo3');
      changeContent({
        ...content,
        imageInfo3: fileUuid,
      });
    }
  }

  function getMaxLengthInput(data) {
    const {maxLength, valueSuffix, valuePrefix} = data;
    return maxLength - ((valueSuffix ? valueSuffix.length : 0) + (valuePrefix ? valuePrefix.length : 0));
  }

  function totalLength(textInfo, textInfoConfig) {
    return (textInfo ? textInfo.length : 0) + (textInfoConfig.valueSuffix.length + textInfoConfig.valuePrefix.length)
  }

  function renderCard1(card) {
    const {config: {imageCampaign}} = card;

    switch (imageCampaign.accept) {
      case 'image/jpg,image/jpeg,image/png':
        return renderCard1Image(card);
      case 'video/mp4':
        return renderCard1Video(card);
      case 'image/gif':
        return renderCard1Gif(card);
    }
  }

  function renderCard1Image(card) {
    const {title, config: {imageCampaign: imageCampaignConfig, textCampaign: textCampaignConfig}} = card;
    return (
      <Card>
        <Header>
          {title}
        </Header>
        <Body>
          <ImagemItem>
            <ImagemItemHeader>
              <UploadImage
                disabled={disabledFields}
                label={content.imageCampaign ? 'Alterar imagem' : 'Buscar imagem'}
                onUpload={uploadImageCampaign}
                accept={imageCampaignConfig.accept}
                onClick={() => {
                  setStatusError({...statusError, messageErrorImageCampaign: ''});
                }}
                maxSize={imageCampaignConfig.maxSize}
                onRejectMaxSize={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageCampaign: `A imagem excedeu o limite de ${formatBytes(imageCampaignConfig.maxSize)}`
                  });
                }}
                styleContainer={{
                  width: 200,
                }}
                style={{
                  width: 200,
                  margin: 0,
                }}
                resolution={imageCampaignConfig.resolution}
                onRejectResolution={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageCampaign: `Arquivo não atendeu as dimensões recomendadas de ${imageCampaignConfig.resolution.width}x${imageCampaignConfig.resolution.height}`
                  });
                }}
              />
              {!!content.imageCampaign && !disabledFields && (
                <Button
                  disabled={disabledFields}
                  title="REMOVER"
                  onClick={() => {
                    changeContent({
                      ...content,
                      imageCampaign: null,
                    });
                  }}
                />
              )}
            </ImagemItemHeader>
            <ImagemEdit>
              <PreviewImageBox
                resolution={imageCampaignConfig.resolution}
                hasImage={!!content.imageCampaign}
              >
                {content.imageCampaign ? (
                  <ImageFromService
                    imageUuid={content.imageCampaign}
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                    styleImage={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <>
                    <span style={{textAlign: 'center'}}>Preview da imagem</span>
                    <span className="resolution-info">
                      {`${imageCampaignConfig.resolution.width}x${imageCampaignConfig.resolution.height}`}
                    </span>
                  </>
                )}
              </PreviewImageBox>
            </ImagemEdit>
            {statusError.messageErrorImageCampaign &&
              <ErrorMessage>{statusError.messageErrorImageCampaign}</ErrorMessage>}
            <ImagemEditInfo>
              <label>
                {textCampaignConfig.label}
                {' - '}
                <small>
                  {`
                  ${totalLength(content.textCampaign, textCampaignConfig)}
                  /
                  ${textCampaignConfig.maxLength} caracteres
                `}
                </small>
              </label>
              <InputCreativeAdvanced
                disabled={disabledFields}
                maxLength={getMaxLengthInput(textCampaignConfig)}
                minLength={textCampaignConfig.minLength}
                type="text"
                style={{width: '100%'}}
                contentVersion={2}
                placeholder={textCampaignConfig.placeholder}
                value={content.textCampaign}
                valueSuffix={textCampaignConfig.valueSuffix}
                valuePrefix={textCampaignConfig.valuePrefix}
                onChange={(e) => {
                  const textCampaign = e.target.value;
                  changeContent({
                    ...content,
                    textCampaign,
                  });
                }}
              />
            </ImagemEditInfo>
          </ImagemItem>
        </Body>
      </Card>
    );
  }

  function renderCard1Video(card) {
    const {
      title,
      config: {thumbnail: imageCampaignConfig, textCampaign: textCampaignConfig, imageCampaign: videoCampaignConfig}
    } = card;
    return (
      <Card>
        <Header>
          {title}
        </Header>
        <Body>
          <ImagemItem>
            <ImagemItemHeader>
              <Upload
                disabled={disabledFields}
                label={content.imageCampaign ? 'Alterar vídeo' : 'Buscar vídeo'}
                onUpload={uploadImageCampaign}
                accept={videoCampaignConfig.accept}
                onClick={() => {
                  setStatusError({...statusError, messageErrorImageCampaign: ''});
                }}
                maxSize={videoCampaignConfig.maxSize}
                onRejectMaxSize={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageCampaign: `O vídeo excedeu o limite de ${formatBytes(videoCampaignConfig.maxSize)}`
                  });
                }}
                styleContainer={{
                  width: 200,
                }}
                style={{
                  width: 200,
                  margin: 0,
                }}
                resolution={videoCampaignConfig.resolution}
                onRejectResolution={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageCampaign: `Arquivo não atendeu as dimensões recomendadas de ${videoCampaignConfig.resolution.width}x${videoCampaignConfig.resolution.height}`
                  });
                }}
              />
              {!!content.imageCampaign && !disabledFields && (
                <Button
                  disabled={disabledFields}
                  title="REMOVER"
                  onClick={() => {
                    changeContent({
                      ...content,
                      imageCampaign: null,
                    });
                  }}
                />
              )}
            </ImagemItemHeader>
            <ImagemEdit>
              <PreviewImageBox
                resolution={videoCampaignConfig.resolution}
                hasImage={!!content.imageCampaign}
              >
                {content.imageCampaign ? (
                  <VideoFromService
                    videoUuid={content.imageCampaign}
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                    stylevideo={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <>
                    <span style={{textAlign: 'center'}}>Preview do video</span>
                    <span className="resolution-info">
                      {videoCampaignConfig.resolution.fixed && `${videoCampaignConfig.resolution.width}x${videoCampaignConfig.resolution.height}`}
                    </span>
                  </>
                )}
              </PreviewImageBox>
            </ImagemEdit>
            <ImagemItemHeader>
              <UploadImage
                disabled={disabledFields}
                label={content.imageCampaign ? 'Alterar thumbnail' : 'Buscar thumbnail'}
                onUpload={uploadThumbnailCampaign}
                accept={imageCampaignConfig.accept}
                onClick={() => {
                  setStatusError({...statusError, messageErrorImageCampaign: ''});
                }}
                maxSize={imageCampaignConfig.maxSize}
                onRejectMaxSize={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageCampaign: `A thumbnail excedeu o limite de ${formatBytes(imageCampaignConfig.maxSize)}`
                  });
                }}
                styleContainer={{
                  width: 200,
                }}
                style={{
                  width: 200,
                  margin: 0,
                }}
                resolution={imageCampaignConfig.resolution}
                onRejectResolution={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageCampaign: `Arquivo não atendeu as dimensões recomendadas de ${imageCampaignConfig.resolution.width}x${imageCampaignConfig.resolution.height}`
                  });
                }}
              />

              {!!content.thumbnail && !disabledFields && (
                <Button
                  disabled={disabledFields}
                  title="REMOVER"
                  onClick={() => {
                    changeContent({
                      ...content,
                      thumbnail: null,
                    });
                  }}
                />
              )}
            </ImagemItemHeader>
            <ImagemEdit>
              <PreviewImageBox
                resolution={imageCampaignConfig.resolution}
                hasImage={!!content.thumbnail}
              >
                {content.thumbnail ? (
                  <ImageFromService
                    imageUuid={content.thumbnail}
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                    styleImage={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <>
                    <span style={{textAlign: 'center'}}>Preview da thumbnail</span>
                    <span className="resolution-info">
                      {`${imageCampaignConfig.resolution.width}x${imageCampaignConfig.resolution.height}`}
                    </span>
                  </>
                )}
              </PreviewImageBox>
            </ImagemEdit>
            {statusError.messageErrorImageCampaign &&
              <ErrorMessage>{statusError.messageErrorImageCampaign}</ErrorMessage>}
            <ImagemEditInfo>
              <label>
                {textCampaignConfig.label}
                {' - '}
                <small>
                  {`
                  ${totalLength(content.textCampaign, textCampaignConfig)}
                  /
                  ${textCampaignConfig.maxLength} caracteres
                `}
                </small>
              </label>
              <InputCreativeAdvanced
                disabled={disabledFields}
                maxLength={getMaxLengthInput(textCampaignConfig)}
                minLength={textCampaignConfig.minLength}
                type="text"
                style={{width: '100%'}}
                contentVersion={2}
                placeholder={textCampaignConfig.placeholder}
                value={content.textCampaign}
                valueSuffix={textCampaignConfig.valueSuffix}
                valuePrefix={textCampaignConfig.valuePrefix}
                onChange={(e) => {
                  const textCampaign = e.target.value;
                  changeContent({
                    ...content,
                    textCampaign,
                  });
                }}
              />
            </ImagemEditInfo>
          </ImagemItem>
        </Body>
      </Card>
    );
  }

  function renderCard1Gif(card) {
    const {
      title,
      config: {thumbnail: imageCampaignConfig, textCampaign: textCampaignConfig, imageCampaign: gifCampaignConfig}
    } = card;
    return (
      <Card>
        <Header>
          {title}
        </Header>
        <Body>
          <ImagemItem>
            <ImagemItemHeader>
              <UploadImage
                disabled={disabledFields}
                label={content.imageCampaign ? 'Alterar GIF' : 'Buscar GIF'}
                onUpload={uploadImageCampaign}
                accept={gifCampaignConfig.accept}
                onClick={() => {
                  setStatusError({...statusError, messageErrorImageCampaign: ''});
                }}
                maxSize={gifCampaignConfig.maxSize}
                onRejectMaxSize={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageCampaign: `O GIF excedeu o limite de ${formatBytes(gifCampaignConfig.maxSize)}`
                  });
                }}
                styleContainer={{
                  width: 200,
                }}
                style={{
                  width: 200,
                  margin: 0,
                }}
                resolution={gifCampaignConfig.resolution}
                onRejectResolution={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageCampaign: `Arquivo não atendeu as dimensões recomendadas de ${gifCampaignConfig.resolution.width}x${gifCampaignConfig.resolution.height}`
                  });
                }}
              />
              {!!content.imageCampaign && !disabledFields && (
                <Button
                  disabled={disabledFields}
                  title="REMOVER"
                  onClick={() => {
                    changeContent({
                      ...content,
                      imageCampaign: null,
                    });
                  }}
                />
              )}
            </ImagemItemHeader>
            <ImagemEdit>
              <PreviewImageBox
                resolution={gifCampaignConfig.resolution}
                hasImage={!!content.imageCampaign}
              >
                {content.imageCampaign ? (
                  <ImageFromService
                    imageUuid={content.imageCampaign}
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                    styleImage={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <>
                    <span style={{textAlign: 'center'}}>Preview do GIF</span>
                    <span className="resolution-info">
                      {!!gifCampaignConfig.resolution.fixed && `${gifCampaignConfig.resolution.width}x${gifCampaignConfig.resolution.height}`}
                    </span>
                  </>
                )}
              </PreviewImageBox>
            </ImagemEdit>
            <ImagemItemHeader>
              <UploadImage
                disabled={disabledFields}
                label={content.imageCampaign ? 'Alterar thumbnail' : 'Buscar thumbnail'}
                onUpload={uploadThumbnailCampaign}
                accept={imageCampaignConfig.accept}
                onClick={() => {
                  setStatusError({...statusError, messageErrorImageCampaign: ''});
                }}
                maxSize={imageCampaignConfig.maxSize}
                onRejectMaxSize={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageCampaign: `A thumbnail excedeu o limite de ${formatBytes(imageCampaignConfig.maxSize)}`
                  });
                }}
                styleContainer={{
                  width: 200,
                }}
                style={{
                  width: 200,
                  margin: 0,
                }}
                resolution={imageCampaignConfig.resolution}
                onRejectResolution={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageCampaign: `Arquivo não atendeu as dimensões recomendadas de ${imageCampaignConfig.resolution.width}x${imageCampaignConfig.resolution.height}`
                  });
                }}
              />

              {!!content.thumbnail && !disabledFields && (
                <Button
                  disabled={disabledFields}
                  title="REMOVER"
                  onClick={() => {
                    changeContent({
                      ...content,
                      thumbnail: null,
                    });
                  }}
                />
              )}
            </ImagemItemHeader>
            <ImagemEdit>
              <PreviewImageBox
                resolution={imageCampaignConfig.resolution}
                hasImage={!!content.thumbnail}
              >
                {content.thumbnail ? (
                  <ImageFromService
                    imageUuid={content.thumbnail}
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                    styleImage={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <>
                    <span style={{textAlign: 'center'}}>Preview da thumbnail</span>
                    <span className="resolution-info">
                      {`${imageCampaignConfig.resolution.width}x${imageCampaignConfig.resolution.height}`}
                    </span>
                  </>
                )}
              </PreviewImageBox>
            </ImagemEdit>
            {statusError.messageErrorImageCampaign &&
              <ErrorMessage>{statusError.messageErrorImageCampaign}</ErrorMessage>}
            <ImagemEditInfo>
              <label>
                {textCampaignConfig.label}
                {' - '}
                <small>
                  {`
                  ${totalLength(content.textCampaign, textCampaignConfig)}
                  /
                  ${textCampaignConfig.maxLength} caracteres
                `}
                </small>
              </label>
              <InputCreativeAdvanced
                disabled={disabledFields}
                maxLength={getMaxLengthInput(textCampaignConfig)}
                minLength={textCampaignConfig.minLength}
                type="text"
                style={{width: '100%'}}
                contentVersion={2}
                placeholder={textCampaignConfig.placeholder}
                value={content.textCampaign}
                valueSuffix={textCampaignConfig.valueSuffix}
                valuePrefix={textCampaignConfig.valuePrefix}
                onChange={(e) => {
                  const textCampaign = e.target.value;
                  changeContent({
                    ...content,
                    textCampaign,
                  });
                }}
              />
            </ImagemEditInfo>
          </ImagemItem>
        </Body>
      </Card>
    );
  }


  function renderCard2(card) {
    const {
      title, config: {
        imageInfo1: imageInfo1Config, textInfo1: textInfo1Config,
        imageInfo2: imageInfo2Config, textInfo2: textInfo2Config,
        imageInfo3: imageInfo3Config, textInfo3: textInfo3Config,
        thumbnail: imageCampaignConfig,
      },
    } = card;

    const uploadComponents = {
      'video/mp4': {Upload, Preview: VideoFromService},
      'image/jpg,image/jpeg,image/png': {Upload: UploadImage, Preview: ImageFromService},
      'image/gif': {Upload: UploadImage, Preview: ImageFromService},
    };

    const nameMedia = {
      'video/mp4': 'vídeo',
      'image/jpg,image/jpeg,image/png': 'imagem',
      'image/gif': 'gif',
    };

    const UploadComponent = uploadComponents[imageInfo1Config.accept] || {Upload, Preview: ImageFromService};

    return (
      <Card>
        <Header>
          {title}
        </Header>
        <Body>
          <ImagemItem>
            <ImagemItemHeader>
              <UploadComponent.Upload
                disabled={disabledFields}
                label={content.imageInfo1 ? `Alterar ${nameMedia[imageInfo1Config.accept]}` : `Buscar ${nameMedia[imageInfo1Config.accept]}`}
                onUpload={uploadImageInfo1}
                onClick={() => {
                  setStatusError({...statusError, messageErrorImageInfo1: ''});
                }}
                accept={imageInfo1Config.accept}
                maxSize={imageInfo1Config.maxSize}
                onRejectMaxSize={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageInfo1: `${nameMedia[imageInfo1Config.accept]} excedeu o limite de ${formatBytes(imageInfo1Config.maxSize)}`
                  });
                }}
                styleContainer={{
                  width: 200,
                }}
                style={{
                  width: 200,
                  margin: 0,
                }}
                resolution={imageInfo1Config.resolution}
                onRejectResolution={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageInfo1: `Arquivo não atendeu as dimensões recomendadas de ${imageInfo1Config.resolution.width}x${imageInfo1Config.resolution.height}`
                  });
                }}
              />
              {!!content.imageInfo1 && !disabledFields && (
                <Button
                  disabled={disabledFields}
                  title="REMOVER"
                  onClick={() => {
                    changeContent({
                      ...content,
                      imageInfo1: null,
                    });
                  }}
                />
              )}
            </ImagemItemHeader>
            <ImagemEdit>
              <PreviewImageBox
                resolution={imageInfo1Config.resolution}
                maxSizePx={300}
                hasImage={!!content.imageInfo1}
              >
                {content.imageInfo1 ? (
                  <UploadComponent.Preview
                    videoUuid={content.imageInfo1}
                    imageUuid={content.imageInfo1}
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                    stylevideo={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                    styleImage={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <>
                    <span style={{textAlign: 'center'}}>Preview de {nameMedia[imageInfo1Config.accept]}</span>
                    <span className="resolution-info">
                      {`${imageInfo1Config.resolution.width}x${imageInfo1Config.resolution.height}`}
                    </span>
                  </>
                )}
              </PreviewImageBox>
            </ImagemEdit>

            {imageCampaignConfig && (
              <>
                <ImagemItemHeader>
                  <UploadImage
                    disabled={disabledFields}
                    label={content.imageCampaign ? 'Alterar thumbnail' : 'Buscar thumbnail'}
                    onUpload={uploadThumbnailCampaign}
                    accept={imageCampaignConfig.accept}
                    onClick={() => {
                      setStatusError({...statusError, messageErrorImageCampaign: ''});
                    }}
                    maxSize={imageCampaignConfig.maxSize}
                    onRejectMaxSize={() => {
                      setStatusError({
                        ...statusError,
                        messageErrorImageCampaign: `A thumbnail excedeu o limite de ${formatBytes(imageCampaignConfig.maxSize)}`
                      });
                    }}
                    styleContainer={{
                      width: 200,
                    }}
                    style={{
                      width: 200,
                      margin: 0,
                    }}
                    resolution={imageCampaignConfig.resolution}
                    onRejectResolution={() => {
                      setStatusError({
                        ...statusError,
                        messageErrorImageCampaign: `Arquivo não atendeu as dimensões recomendadas de ${imageCampaignConfig.resolution.width}x${imageCampaignConfig.resolution.height}`
                      });
                    }}
                  />

                  {!!content.thumbnail && !disabledFields && (
                    <Button
                      disabled={disabledFields}
                      title="REMOVER"
                      onClick={() => {
                        changeContent({
                          ...content,
                          thumbnail: null,
                        });
                      }}
                    />
                  )}
                </ImagemItemHeader>
                <ImagemEdit>
                  <PreviewImageBox
                    resolution={imageCampaignConfig.resolution}
                    maxSizePx={300}
                    hasImage={!!content.thumbnail}
                  >
                    {content.thumbnail ? (
                      <ImageFromService
                        imageUuid={content.thumbnail}
                        style={{
                          width: '100%',
                          height: '100%',
                        }}
                        styleImage={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    ) : (
                      <>
                        <span style={{textAlign: 'center'}}>Preview da thumbnail</span>
                        <span className="resolution-info">
                      {`${imageCampaignConfig.resolution.width}x${imageCampaignConfig.resolution.height}`}
                    </span>
                      </>
                    )}
                  </PreviewImageBox>
                </ImagemEdit>
              </>
            )}


            {statusError.messageErrorImageInfo1 && <ErrorMessage>{statusError.messageErrorImageInfo1}</ErrorMessage>}
            <ImagemEditInfo>
              <label>
                {textInfo1Config.label}
                {' - '}
                <small>
                  {`
                  ${totalLength(content.textInfo1, textInfo1Config)}
                  /
                  ${textInfo1Config.maxLength} caracteres
                `}
                </small>
              </label>
              <InputCreativeAdvanced
                disabled={disabledFields}
                maxLength={getMaxLengthInput(textInfo1Config)}
                minLength={textInfo1Config.minLength}
                type="text"
                contentVersion={2}
                placeholder={textInfo1Config.placeholder}
                value={content.textInfo1}
                valueSuffix={textInfo1Config.valueSuffix}
                valuePrefix={textInfo1Config.valuePrefix}
                onChange={(e) => {
                  const textInfo1 = e.target.value;
                  changeContent({
                    ...content,
                    textInfo1,
                  });
                }}
              />
            </ImagemEditInfo>
          </ImagemItem>
          <Separator/>
          <ImagemItem>
            <ImagemItemHeader>
              <UploadImage
                disabled={disabledFields}
                label={content.imageInfo2 ? 'Alterar imagem' : 'Buscar imagem'}
                onUpload={uploadImageInfo2}
                onClick={() => {
                  setStatusError({...statusError, messageErrorImageInfo2: ''});
                }}
                accept={imageInfo2Config.accept}
                maxSize={imageInfo2Config.maxSize}
                onRejectMaxSize={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageInfo2: `A imagem excedeu o limite de ${formatBytes(imageInfo2Config.maxSize)}`
                  });
                }}
                styleContainer={{
                  width: 200,
                }}
                style={{
                  width: 200,
                  margin: 0,
                }}
                resolution={imageInfo2Config.resolution}
                onRejectResolution={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageInfo2: `Arquivo não atendeu as dimensões recomendadas de ${imageInfo2Config.resolution.width}x${imageInfo2Config.resolution.height}`
                  });
                }}
              />
              {!!content.imageInfo2 && !disabledFields && (
                <Button
                  disabled={disabledFields}
                  title="REMOVER"
                  onClick={() => {
                    changeContent({
                      ...content,
                      imageInfo2: null,
                    });
                  }}
                />
              )}
            </ImagemItemHeader>
            <ImagemEdit>
              <PreviewImageBox
                resolution={imageInfo2Config.resolution}
                maxSizePx={300}
                hasImage={!!content.imageInfo2}
              >
                {content.imageInfo2 ? (
                  <ImageFromService
                    imageUuid={content.imageInfo2}
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                    styleImage={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <>
                    <span style={{textAlign: 'center'}}>Preview da imagem</span>
                    <span className="resolution-info">
                      {`${imageInfo2Config.resolution.width}x${imageInfo2Config.resolution.height}`}
                    </span>
                  </>
                )}
              </PreviewImageBox>
            </ImagemEdit>
            {statusError.messageErrorImageInfo2 && <ErrorMessage>{statusError.messageErrorImageInfo2}</ErrorMessage>}
            <ImagemEditInfo>
              <label>
                {textInfo2Config.label}
                {' - '}
                <small>
                  {`
                  ${totalLength(content.textInfo2, textInfo2Config)}
                  /
                  ${textInfo2Config.maxLength} caracteres
                `}
                </small>
              </label>
              <InputCreativeAdvanced
                disabled={disabledFields}
                maxLength={getMaxLengthInput(textInfo2Config)}
                minLength={textInfo2Config.minLength}
                type="text"
                contentVersion={2}
                placeholder={textInfo2Config.placeholder}
                value={content.textInfo2}
                valueSuffix={textInfo2Config.valueSuffix}
                valuePrefix={textInfo2Config.valuePrefix}
                onChange={(e) => {
                  const textInfo2 = e.target.value;
                  changeContent({
                    ...content,
                    textInfo2,
                  });
                }}
              />
            </ImagemEditInfo>
          </ImagemItem>
          <Separator/>
          <ImagemItem>
            <ImagemItemHeader>
              <UploadImage
                disabled={disabledFields}
                label={content.imageInfo3 ? 'Alterar imagem' : 'Buscar imagem'}
                onUpload={uploadImageInfo3}
                onClick={() => {
                  setStatusError({...statusError, messageErrorImageInfo3: ''});
                }}
                accept={imageInfo3Config.accept}
                maxSize={imageInfo3Config.maxSize}
                onRejectMaxSize={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageInfo3: `A imagem excedeu o limite de ${formatBytes(imageInfo3Config.maxSize)}`
                  });
                }}
                styleContainer={{
                  width: 200,
                }}
                style={{
                  width: 200,
                  margin: 0,
                }}
                resolution={imageInfo3Config.resolution}
                onRejectResolution={() => {
                  setStatusError({
                    ...statusError,
                    messageErrorImageInfo3: `Arquivo não atendeu as dimensões recomendadas de ${imageInfo3Config.resolution.width}x${imageInfo3Config.resolution.height}`
                  });
                }}
              />
              {!!content.imageInfo3 && !disabledFields && (
                <Button
                  disabled={disabledFields}
                  title="REMOVER"
                  onClick={() => {
                    changeContent({
                      ...content,
                      imageInfo3: null,
                    });
                  }}
                />
              )}
            </ImagemItemHeader>
            <ImagemEdit>
              <PreviewImageBox
                resolution={imageInfo3Config.resolution}
                maxSizePx={300}
                hasImage={!!content.imageInfo3}
              >
                {content.imageInfo3 ? (
                  <ImageFromService
                    imageUuid={content.imageInfo3}
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                    styleImage={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                ) : (
                  <>
                    <span style={{textAlign: 'center'}}>Preview da imagem</span>
                    <span className="resolution-info">
                      {`${imageInfo3Config.resolution.width}x${imageInfo3Config.resolution.height}`}
                    </span>
                  </>
                )}
              </PreviewImageBox>
            </ImagemEdit>
            {statusError.messageErrorImageInfo3 && <ErrorMessage>{statusError.messageErrorImageInfo3}</ErrorMessage>}
            <ImagemEditInfo>
              <label>
                {textInfo3Config.label}
                {' - '}
                <small>
                  {`
                  ${totalLength(content.textInfo3, textInfo3Config)}
                  /
                  ${textInfo3Config.maxLength} caracteres
                `}
                </small>
              </label>
              <InputCreativeAdvanced
                disabled={disabledFields}
                maxLength={getMaxLengthInput(textInfo3Config)}
                minLength={textInfo3Config.minLength}
                type="text"
                contentVersion={2}
                placeholder={textInfo3Config.placeholder}
                value={content.textInfo3}
                valueSuffix={textInfo3Config.valueSuffix}
                valuePrefix={textInfo3Config.valuePrefix}
                onChange={(e) => {
                  const textInfo3 = e.target.value;
                  changeContent({
                    ...content,
                    textInfo3,
                  });
                }}
              />
            </ImagemEditInfo>
          </ImagemItem>
        </Body>
      </Card>
    );
  }

  function renderCard3(card) {
    const {title, config: {textDuploOptin: textDuploOptinConfig}} = card;
    return (
      <Card>
        <Header>
          {title}
        </Header>
        <Body>
          <BaseContentInput>
            <label>
              {textDuploOptinConfig.label}
              {' - '}
              <small>
                {`
                  ${totalLength(content.textDuploOptin, textDuploOptinConfig)}
                  /
                  ${textDuploOptinConfig.maxLength} caracteres
                `}
              </small>
            </label>
            <InputCreativeAdvanced
              disabled={disabledFields}
              maxLength={getMaxLengthInput(textDuploOptinConfig)}
              minLength={textDuploOptinConfig.minLength}
              type="text"
              style={{width: '100%'}}
              contentVersion={2}
              placeholder={textDuploOptinConfig.placeholder}
              value={content.textDuploOptin}
              valueSuffix={textDuploOptinConfig.valueSuffix}
              valuePrefix={textDuploOptinConfig.valuePrefix}
              onChange={(e) => {
                changeContent({
                  ...content,
                  textDuploOptin: e.target.value,
                });
              }}
            />
          </BaseContentInput>
        </Body>
      </Card>
    );
  }

  function renderCard4(card) {
    const {title, config: {successInfo}} = card;
    return (
      <Card>
        <Header>
          {title}
        </Header>
        <Body>
          <SuccessInfoCard4>{successInfo}</SuccessInfoCard4>
        </Body>
      </Card>
    );
  }

  return (
    <Container>
      {rest && Object.keys(rest).length > 0 && (
        <select
          value={mediaType || ''}
          onChange={(e) => {
            const selectedKey = e.target.value;
            if (rest[selectedKey]) {
              setCardsData(rest[selectedKey].cards);
              changeContent({
                mediaType: selectedKey
              })
            }
          }}
        >
          {Object.keys(rest).map((key) => (
              key && <option key={key} value={key}>
                {key.charAt(0).toUpperCase() + key.slice(1)}
              </option>
            )
          )}
        </select>
      )}
      {cardsData.card1 && renderCard1(cardsData.card1)}
      {cardsData.card2 && renderCard2(cardsData.card2)}
      {cardsData.card3 && renderCard3(cardsData.card3)}
      {cardsData.card4 && renderCard4(cardsData.card4)}
    </Container>
  );
};

RCSClaroForm.propTypes = {
  campaign: PropTypes.shape().isRequired,
  criativoEdit: PropTypes.shape().isRequired,
  campaignEditCriativoRequestSuccess: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  disabledFields: PropTypes.bool.isRequired,

  startRequest: PropTypes.func.isRequired,
  requestSuccess: PropTypes.func.isRequired,
  requestError: PropTypes.func.isRequired,
  errorMessage: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    startRequest: requestLoading,
    requestSuccess: successLoading,
    requestError: errorLoading,
    errorMessage: ToastrMessageActions.errorMessage,
  },
  dispatch,
);

export default connect(
  null,
  mapDispatchToProps,
)(RCSClaroForm);
